import * as $ from 'jquery';
import { isEnableLineItemCost } from './utils';

/**
 * Generates HTML options for a given size.
 *
 * @param {number} size - The size up to which the options should be generated.
 */
export function generateComponentSizeOption(size) {
	if (size) {
		let result = '';

		for (let i = 2; i <= size; i++) {
			result += `<option value="${i}">${i}</option>`;
		}

		$('.component_size').html(result);
	}
}

/**
 * Determines if the "show position components" class is present on the body element.
 *
 * @returns {boolean} True if the body element has the "show-position-components" class, otherwise false.
 */

export const isShowComponentPosition = () => {
	return $('body.show-position-components').length ? true : false;
};

/**
 * Handles search input in custom select dropdown.
 * Hides options that don't contain the search string.
 * @param {Event} e - The input event.
 */
export const handleSearchCustomSelect = (e) => {
	const content = e.target.value.replace(/ /g, '');
	const items = $(e.target).parent().children();
	for (let i = 1; i < items.length; i++) {
		const option = $(items[i]).text().replace(/ /g, '');
		if (-1 !== option.indexOf(content)) {
			$(items[i]).removeClass('hide-custom-option');
		} else {
			$(items[i]).addClass('hide-custom-option');
		}
	}
};

/**
 * Adds a warning message to the given element.
 *
 * @param {string} className CSS class name for the warning message.
 * @param {string} text The warning message to be displayed.
 * @returns {string} The HTML string for the warning message.
 */
export const addWarningMessage = (className, text) => {
	return `<div class="${className}" class="section-detail" style="padding: 0px; margin-bottom: 10px; font-style: italic; font-size: 0.9em; text-transform: none;"><span style="margin-right: 6px;" class="icon-warning-bold"></span>${text}</div>`;
};

/**
 * Get the price element based on the provided price.
 *
 * @param {string|number} price - The price to display.
 * @returns {string} - The HTML string representing the price element.
 */
export const getPriceElement = (price, isShowPrice, isShowUpgradeCharge = true) => {
	if (!isShowPrice || !isShowUpgradeCharge) {
		return '';
	}

	if (!isEnableLineItemCost()) {
		return '';
	}

	if ('(included)' === price || '' === price || 0 == price) {
		return '<p class="right">(included)</p>';
	}

	if ('(n/a)' === price || '(call for pricing)' === price) {
		return `<p class="right">${price}</p>`;
	}

	return `<p class="right">${formatPrice(price)}</p>`;
};

/**
 * Format Price with USD
 * @param {Number} price price of one item
 */
export const formatPrice = (price) => {
	return renderPrice(price);
};

/**
 * Formats a price with USD currency
 * @param {number} price - the price to be formatted
 * @returns {string} - the formatted price
 */
export const renderPrice = (price) => {
	return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price);
};
